var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20898 8.55566C4.95605 8.55566 5.65918 8.34082 6.25488 7.96973L8.2666 9.98145C8.42773 10.1426 8.64746 10.2207 8.87207 10.2207C9.3457 10.2207 9.70215 9.85449 9.70215 9.38086C9.70215 9.16602 9.62891 8.95117 9.46289 8.79004L7.4707 6.79297C7.88086 6.17285 8.11523 5.43555 8.11523 4.64453C8.11523 2.49609 6.35742 0.733398 4.20898 0.733398C2.06055 0.733398 0.297852 2.49121 0.297852 4.64453C0.297852 6.79297 2.06055 8.55566 4.20898 8.55566ZM4.20898 7.36426C2.70996 7.36426 1.48438 6.13867 1.48438 4.64453C1.48438 3.15039 2.70996 1.9248 4.20898 1.9248C5.70312 1.9248 6.92871 3.15039 6.92871 4.64453C6.92871 6.13867 5.70312 7.36426 4.20898 7.36426Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.22df39ceadd0b5dab58259db132a8db7.svg";
export { ForwardRef as ReactComponent };